/* import __COLOCATED_TEMPLATE__ from './show-preview-column.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import type HelpCenterSite from 'embercom/models/help-center-site';

interface Args {
  selectedHelpCenter: HelpCenterSite;
}

interface Signature {
  Args: Args;
}

export default class TicketsPortalShowPreviewColumn extends Component<Signature> {
  @action
  toggleShowPreviewColumn() {
    this.args.selectedHelpCenter.ticketsPortalPreviewColumnEnabled =
      !this.args.selectedHelpCenter.ticketsPortalPreviewColumnEnabled;
  }

  get isShowPreviewColumnEnabled() {
    return this.args.selectedHelpCenter.ticketsPortalPreviewColumnEnabled;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Helpdesk::Tickets::TicketsPortal::ShowPreviewColumn': typeof TicketsPortalShowPreviewColumn;
    'new-settings/helpdesk/tickets/tickets-portal/show-preview-column': typeof TicketsPortalShowPreviewColumn;
  }
}
